// BjxyPage.jsx — /bjxy 页面 8 section 完整渲染
// v0.2.0ebb16a0.c 改 (辉哥 2026-09-04 22:57 反馈): 改 extends vendor Page, view() 走 vendor PageStructure
//   走 vendor 4 层容器 Page.IndexPage > Page-pane + Page-main > Page-hero + Page-container > Page-sidebar + Page-content
//   button 父链 1:1 跟 /all 一致 (走 vendor IndexSidebar 自动渲染 newDiscussion)
//   删除 c.20 段 ul+li+button 段 (BjxyPage.jsx view() 渲染) + bjxy-mobile-cta-* less 段
//   删除 bjxy-page / bjxy-page-bg 段 (走 vendor PageStructure 自动)
//   保留 8 section 渲染方法 (走 vendor Page-content slot, 接受 700px 容器 trade-off)
//   保留 hero section (走 vendor Page-hero slot, full-width 100vw)
//   保留 BookingModal 触发 (改在自定义 BjxySidebar.newDiscussion.onclick)
//   保留 setTitle / oninit history push / sessionStorage / body class / onremove body class remove
// 8 section settings 走 app.forum.attribute('bjxy_*') (SOP 56)
// 17 级 + 6 特色 走 app.data.bjxyCurriculum / bjxyFeatures (vendor custom payload)
// v0.1.6a: 评价多图 (大众点评风格) + 活动展示 swiper 轮播 + 复用 ziven-core fancybox
//   复用 ziven-core 的 app.fancyboxOpen 跟 window.Fancybox (ziven-core/forum/index.js 静态加载)
//   swiper 走本地 npm install (跟 sortablejs v0.1.4 一样路线)
import app from 'flarum/forum/app';
// v0.2.0ebb16a0.c 改: Component → Page (vendor 基类)
//   走 vendor Page 自动处理: app.previous = app.current + app.current = new PageState(...)
//     + app.drawer.hide() + app.modal.close() (vendor Page.oninit L32-40)
//   走 vendor Page 自动处理: bodyClass add/remove (vendor Page.oncreate L42-46 + onremove L58-63)
//   走 vendor Page 自动处理: scrollTopOnCreate + useBrowserScrollRestoration (vendor Page.oncreate L49-55)
//   不走 vendor IndexPage 那堆副作用: app.discussions.refreshParams 拉讨论列表 + hero 高度计算 + scroll 恢复
//     (bjxy 不需要, 改 extends Page 而不是 IndexPage, 减少 4 段 vendor 副作用)
import Page from 'flarum/common/components/Page';
// v0.2.0ebb16a0.c 加: import vendor PageStructure 模板
//   走 vendor 4 层容器: <div class="Page IndexPage"> > Page-pane + Page-main(id="page-main") > Page-hero + Page-container > Page-sidebar + Page-content(id="main-content")
//   跟 vendor IndexPage.view() 模式 1:1 一致 (vendor IndexPage.tsx L64-70)
import PageStructure from 'flarum/forum/components/PageStructure';
// v0.1.6a: 引入 swiper ES module
// v0.1.6c 改: swiper 11 navigation/pagination 是独立 modules, 必须显式 import + 传 modules: [...]
//   之前 v0.1.6a+b 只 import Swiper default, swiper 11 默认不 attach navigation/pagination
//   (modules 数组只有 ['0', '1'] 表示 core + virtual), 按钮 click 没绑 event
//   辉哥 12:55 反馈 "swiper 左右切换箭头点击没效果", 确认 navigation 初始化失败
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
// v0.2.0ebb16a0.c 改: import BookingModal 不在 BjxyPage.jsx 用了
//   BookingModal 改在自定义 BjxySidebar.jsx 用 (BjxySidebar.newDiscussion.onclick)
//   这里保留 import 以备其他场景 (例如 hero section 的 CTA button) — 实际无引用
// import BookingModal from './BookingModal';
// v0.2.0ebb16a0.c 加: import bjxy 自定义 sidebar
//   复制 vendor IndexSidebar 模板, 替换 newDiscussion.onclick 弹 BookingModal, 删 nav (SelectDropdown)
//   走 vendor PageStructure.sidebar() slot, 跟 /all 1:1 DOM 一致
import BjxySidebar from './BjxySidebar';
// v0.2.0ebb16a0.c 加: import vendor ItemList (SOP 327 mithril 0.2.x fragment 修法)
//   renderContactSection addressBlock 内部 children 走 ItemList, 保证 toArray() 返纯 keyed 或纯 unkeyed, 不混 hole
//   实战教训: 任何含动态数组 (map) + 条件项 (null hole) 的 children, 必走 ItemList 避免 mithril fragment 报错
import ItemList from 'flarum/common/utils/ItemList';
const DEFAULT_BRAND = '北极雪屿';
const DEFAULT_SLOGAN = '室内滑雪 · 全国连锁';
export default class BjxyPage extends Page {
  // v0.2.0ebb16a0.c 改: 走 vendor Page 自动, bodyClass = 'App--index' (跟 vendor IndexPage 一致)
  //   vendor Page.oncreate L42-46 走 $('#app').addClass(this.bodyClass) (注意是 #app 不是 body)
  //   跟 v0.2.0i.i 时代手动 document.body.classList.add 的 body class 不同 (那个 class 本轮起已彻底删除, 见 v0.2.0ebb16a0.c.f.m.e.14)
  //   'App--index' 是 vendor page-level body class, Flarum 2.0 默认 vendor 主题 (ziven-theme-aura) 可能用它做样式
  //   保留它对 1:1 跟 /all 一致有利 (vendor IndexPage 走同一个 bodyClass)
  bodyClass = 'App--index';
  // v0.2.0ebb16a0.c 改: 走 vendor Page 自动, scrollTopOnCreate = false (跟 vendor IndexPage 一致)
  //   vendor Page.oncreate L49-51 走 $(window).scrollTop(0) 默认 true, IndexPage 改 false
  //   bjxy 也走 false, 用户滚动到 hero section 时不会跳到顶 (跟 /all 一致)
  scrollTopOnCreate = false;

  // v0.1.22: /bjxy 路径 title 改为品牌名 + 品牌副标 (辉哥 18:38 新需求)
  //   override vendor Page.setTitle() 默认行为 (vendor Page 没默认 setTitle, IndexPage 走 vendor 默认)
  //   不调 vendor 默认 setTitle, 完全自定义. 走 bjxy_brand_name / bjxy_brand_slogan setting,
  //   后台 '品牌信息' tab 配置 (BjxySettings.jsx L511-519), 留空时 fallback 到 '北极雪屿' + '室内滑雪 · 全国连锁'
  setTitle() {
    const brandName = app.forum.attribute('bjxy_brand_name') || DEFAULT_BRAND;
    const brandSlogan = app.forum.attribute('bjxy_brand_slogan') || DEFAULT_SLOGAN;
    app.setTitle(brandName + ' · ' + brandSlogan);
    app.setTitleCount(0);
  }

  // v0.2.0ebb16a0.c.b 改 (辉哥 2026-09-05 00:46 反馈): 恢复 oncreate + loadCoaches (Coder c.6 误删)
  //   现象: 辉哥 9/5 00:46 反馈 "其他的section你也都看一下", 实际 bjxy.top 教练 section 显示 "暂无教练" (永远空)
  //   根因: Coder c.6 改 PageStructure 模板时, 误删 oncreate (调 setTitle + loadCoaches) + loadCoaches 方法
  //     - oninit 保留 this.coaches = [] + this.loadingCoaches = true 初始 state
  //     - 但没了 oncreate 调 this.loadCoaches() 触发 API 请求
  //     - this.coaches 永远 [], renderCoachSection 永远走 '暂无教练' 分支
  //   修法: 恢复 oncreate (调 super.oncreate + setTitle + loadCoaches) + loadCoaches 方法 (跟 ebb16a0 L999-1016 一致)
  //   配套: revert renderCoachSection 整段 (32 行简化: swiper 简化为 null + h2 fallback '认证教练' 改错 setting key + 删 emoji + 删 srcset retina + 改 class 加 bjxy-section-alt)
  //   super.oncreate(vnode) 必要: vendor Page.oncreate L42-46 走 bodyClass add + L49-51 scrollTopOnCreate + L53-55 scrollRestoration, 跳过 super 会丢 bodyClass add (App--index)
  oncreate(vnode) {
    super.oncreate(vnode);
    // v0.1.22: /bjxy 路径 HTML <title> 改为品牌名 + 品牌副标
    //   vendor Page setTitle 默认 setTitle(trans('core.forum.index.meta_title_text')) = '极客雪域'
    //   override 后变成 '北极雪屿 · 室内滑雪 · 全国连锁' (跟后台 '品牌信息' tab 设置联动)
    this.setTitle();
    this.loadCoaches();
  }
  loadCoaches() {
    // v0.1.4 改: 优先用 /api/bjxy/coaches (读 bjxy_coach_user_ids setting, 拿具体 user)
    //   fallback 老的 /api/bjxy/coaches (读 bjxy_coach_group_ids setting, 拿 group 内 user)
    //   两个 API 共存兼容旧部署
    m.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/bjxy/coaches'
    }).then(data => {
      this.coaches = data.coaches || [];
      this.loadingCoaches = false;
      m.redraw();
    }).catch(err => {
      console.error('bjxy load coaches failed', err);
      this.loadingCoaches = false;
      m.redraw();
    });
  }
  oninit(vnode) {
    super.oninit(vnode);
    // v0.2.0i.k 新 (辉哥 2026-08-12 16:05 反馈): oninit push history 让返回按钮能跳回 bjxy
    //   根因: vendor Navigation 组件 L33 canGoBack() = stack.length > 1, 没 push 就不显示
    //   修法: 跟 vendor IndexPage L57 / PostsPage L33 / UserPage L85 模式一致
    //   History.push() L41-46 检查 top 同名会覆盖, 不会 stack 重复
    //   返回按钮跳回 /bjxy (直接路径, 不依赖 default_route 配置)
    //   适用: 任何 bjxy 自定义 page 都要 push history entry, 否则跳其他页面没返回按钮
    app.history.push('bjxy', 'bjxy 官网', '/bjxy');
    // v0.2.0i.k.b 新 (辉哥 2026-08-12 17:35 反馈): sessionStorage 持久化 bjxy 路径 + active flag
    //   背景: vendor History 是 session-only 内存, 刷新后 mithril 重建 stack, bjxy entry 丢
    //   辉哥实测: 刷新 /u/wfl → stack 变成 [user.posts], 没 bjxy entry, 返回按钮跳 / (首页)
    //   修法: 把 bjxy path + active flag 写到 sessionStorage, forum/index.js 劫持 m.route.set 在跳 /u/... 时 push bjxy entry
    //   两个 key 用途不同:
    //     - 'ziven-bjxy-prev-path' = '/bjxy': 持久化 prev path (备用, 实际劫持用 active flag)
    //     - 'ziven-bjxy-active' = '1': 标志用户在当前 SPA session 内访问过 bjxy (劫持判断条件, 区分 /d/1 → /u/ 副作用)
    //   配合: forum/index.js 注入 m.route.set 劫持器, 在 /u/ 跳转前 push bjxy entry (仅当 active='1')
    //   关键: onremove 清 active (避免 /d/1 → /u/ 副作用, 详见 forum/index.js 注释)
    try {
      sessionStorage.setItem('ziven-bjxy-prev-path', '/bjxy');
      sessionStorage.setItem('ziven-bjxy-active', '1');
    } catch (e) {
      // sessionStorage 可能被禁用 (隐私模式), 静默失败
    }
    this.coaches = [];
    this.loadingCoaches = true;
    // v0.1.0s 改: activeBoard 从 string 'single' 改成 index (0/1/2...)
    //   因为现在 boards 数组任意多类型, 不再固定 2 个
    this.activeBoard = 0;
    // v0.2.0i.i 新 (辉哥 2026-08-12 07:42 反馈): bjxy 官网桌面端 sidebar 收起 + display:none
    //   App-sidebar-aura 来源: ziven-theme-aura vendor 扩展 (vendor/ziiven/theme-aura/)
    //   辉哥要: bjxy 官网桌面端 sidebar 不可见 (不是 vendor 折叠 transform 动画)
    //   修法: page-level 控制 body class
    //     - oninit add class 'bjxy-page-active' (bjxy 自己的 page-level class, 只有官网页有)
    //     - onremove remove class (切回 /d /u /all 等其他路径, sidebar 恢复 vendor 默认)
    //   CSS 配合 less/forum.less 桌面端段: body.bjxy-page-active .App-sidebar-aura { display: none !important }
    //   风险: 跟 vendor localStorage 'ziven-aura-sidebar-collapsed' 独立, 不会冲突 (vendor modifySidebar.js 只看 localStorage, 不查 body class)
    //   mobile 不动: CSS 套 @media (min-width: 992px), mobile 走 vendor 移动端 drawer
    // v0.2.0ebb16a0.c.f.m.e.14 改 (2026-10-21): 桌面端 sidebar 隐藏不再借用 aura 的 body class
    //   改前: oninit add / onremove remove body class 'App-sidebar-aura-collapsed' (跟 ziven-theme-aura 撞名)
    //   改后: 跟 'bjxy-page-active' 合并成同一个 class, 少一个要增删的 body class, 也不再占用 aura 的命名空间
    //   根因: 'App-sidebar-aura-collapsed' 这个名字属于 ziven-theme-aura (aura 那边语义是「用户手动折叠了侧边栏」),
    //     bjxy 借用它只是历史遗留 —— 两个语义完全不同的事共用一个 body class 名.
    //     ziven-theme-aura v0.2.8 r.26 那次「折叠后 toggle 永久消失、再也展不开」的死胡同, 就是这两个扩展撞名造成的.
    //   触发条件不变: 'bjxy-page-active' 本来就只在 bjxy 官网页存在, 所以隐藏 sidebar 的生效范围跟改之前一模一样.
    // v0.2.0i.n 新 (辉哥 2026-08-13 12:00 反馈): page-level body class 控制 mobile tab 隐藏 + #app padding-top
    //   走 SOP 234 page-level 套路, 跟 v0.2.0i.i 桌面端 sidebar 隐藏段一致
    //   之前 v0.1.17~v0.2.0i.l 都用 oncreate 注入 <style id="bjxy-hide-mobile-tab">, 漏 onremove 清理
    //     跨路由污染下一个页面 (移动端 /u/wfl 多 17.8px padding)
    //   修法: 改成 less 段 + body class, oninit add class, onremove remove class
    //   v0.2.0r.a 改 (辉哥 2026-08-29 拍板): 删 nav.MobileTab 隐藏那段
    //   v0.2.0i.aa.a 改 (辉哥 2026-08-31 16:21 反馈): bjxy 顶部恢复 vendor Flarum 原生 top bar, 删 #header hide + #app padding-top 63.8 2 段死代码
    //     (v0.2.0i.aa 撤回调后 bjxy 自建 bjxy-nav 不在了, 那 2 段作用是"藏 vendor #header + 给 bjxy-nav 留位置", 变死代码, 删掉)
    //   v0.2.0i.aa.b 改 (辉哥 2026-08-31 16:46 拍板 A 方案): 删整个 bjxy 自建导航 (logo + 7 锚点 + 预约体验按钮), bjxy 顶部完全走 vendor Flarum 原生 top bar
    //     配套 less 段 (v0.2.0i.aa.b 当前 5 段): body.bjxy-page-active { footer.App-footer hide; div.coreFooter hide; .App.affix pb 0; .App-content pb 0; .MobileTab z-index 1200; }
    //   老 fallback: onremove 兜底 getElementById("bjxy-hide-mobile-tab")?.remove() 兼容老 user 老 cache
    if (typeof document !== 'undefined' && document.body) {
      // v0.2.0i.n: 加 page-level class
      document.body.classList.add('bjxy-page-active');
    }
  }

  // v0.1.6: 评分转 ★☆ 字符串 (1-5 整数)
  renderStars(rating) {
    const r = Math.max(1, Math.min(5, parseInt(rating) || 5));
    return '★'.repeat(r) + '☆'.repeat(5 - r);
  }

  // v0.1.6a: fancybox 多图 gallery 工具
  //   复用 ziven-core 的 window.Fancybox (ziven-core/forum/index.js 静态加载)
  //   直接调 Fancybox.show 不依赖 app.fancyboxOpen (那个只支持单图)
  //   等 window.Fancybox 加载完成 (ziven-core 是静默加载, 可能 page render 时还没好)
  openFancyboxGallery(urls, idx) {
    if (idx === void 0) {
      idx = 0;
    }
    if (!urls || urls.length === 0) return;
    const doOpen = () => {
      if (window.Fancybox && window.Fancybox.show) {
        window.Fancybox.show(urls.map(u => ({
          src: u,
          type: 'image'
        })), {
          startIndex: idx,
          dragToClose: false
        });
      } else {
        console.warn('Fancybox not loaded yet, retry...');
      }
    };
    if (window.Fancybox && window.Fancybox.show) {
      doOpen();
    } else {
      // 触发 ziven-core 加载, 然后轮询等
      if (app && app.fancyboxOpen) app.fancyboxOpen(urls[0]);
      let attempts = 0;
      const check = setInterval(() => {
        attempts++;
        if (window.Fancybox && window.Fancybox.show) {
          clearInterval(check);
          doOpen();
        } else if (attempts > 50) {
          clearInterval(check);
          console.error('Fancybox load timeout');
        }
      }, 100);
    }
  }

  // v0.1.6a: swiper 初始化 (评价/活动 轮播)
  //   vnode.dom 是 swiper container
  //   onremove 时销毁避免内存泄漏
  // v0.1.6c 改: 加 modules: [Navigation, Pagination]
  // v0.1.6g 改: 加 Autoplay module, delay 从 bjxy_events_autoplay_ms setting 读
  //   delay 默认 3000ms, disableOnInteraction=false 用户操作后继续自动轮播
  initSwiper(vnode) {
    if (!vnode || !vnode.dom) return;
    if (this.swiper) this.swiper.destroy(true, true);
    const autoplayMs = parseInt(app.forum.attribute('bjxy_events_autoplay_ms'), 10) || 3000;
    this.swiper = new Swiper(vnode.dom, {
      // v0.1.6c: 必须传 modules, 不传 swiper 11 navigation/pagination 不会 attach
      // v0.1.6g: 加 Autoplay module (SOP 90)
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      // v0.2.0h 改: 显式分 3 段 viewport (辉哥 14:15 反馈, 跟 v0.1.38 768+ 跳 desktop 2 累计)
      //   mobile (< 768px) 1, tablet (768-1024) 2, desktop (>= 1024) 2
      //   swiper 11 breakpoints 触发 slidesPerView 切换, 跟 v0.1.30 swiper peek breakpoints 模式一致
      //   events 段 tablet + desktop 都 2 卡 (跟 v0.1.38 行为不变, 显式分段)
      slidesPerView: 1,
      spaceBetween: 16,
      // v0.2.0i.o 改: 移动端 events swiper 修法 (辉哥 16:00 反馈 /bjxy 最新活动图片 fancybox 不弹)
      //   根因: swiper 11 移动端默认配置, 第一个 slide 在 viewport 左侧外 (Puppeteer x=-179)
      //   + swiper 11 默认 preventClicks=true 拦截 photo click
      //   修法: centeredSlides + initialSlide + preventClicks: false + noSwipingClass 4 件套
      //   - centeredSlides: 移动端首张居中, 解决"首张在 viewport 外"问题
      //   - initialSlide: 0: 强制从第 0 张开始, 跟 loop: true 兼容
      //   - preventClicks: false: 不拦截 photo click, 走 onclick 调 fancybox
      //     注意: preventClicks 是顶层 config, 不能在 breakpoints 里覆盖
      //   - noSwipingClass: photo 跳过 swiping 拦截, 万一上面一个不够
      //   桌面端不受影响 (desktop slidesPerView=2 + 鼠标 click 不走 touchstart, swiper 不拦截)
      //   桌面端 breakpoints 显式关 centeredSlides (桌面 slidesPerView=2, 居中没意义还会挤)
      centeredSlides: true,
      initialSlide: 0,
      preventClicks: false,
      noSwipingClass: 'bjxy-event-photo',
      breakpoints: {
        768: {
          // v0.2.0h: tablet 768-1024, 2 卡
          slidesPerView: 2,
          // v0.2.0i.o: 桌面端关 centeredSlides (tablet slidesPerView=2, 居中没意义还会挤)
          centeredSlides: false,
          noSwipingClass: 'bjxy-event-photo'
        },
        1024: {
          // v0.2.0h: desktop >= 1024, 2 卡 (跟 tablet 一样, 显式分段)
          slidesPerView: 2,
          // v0.2.0i.o: desktop 关 centeredSlides
          centeredSlides: false,
          noSwipingClass: 'bjxy-event-photo'
        }
      },
      pagination: {
        el: vnode.dom.querySelector('.swiper-pagination'),
        clickable: true
      },
      // v0.1.6g: 自动轮播配置 (后台 bjxy_events_autoplay_ms, 默认 3000ms)
      autoplay: {
        delay: autoplayMs,
        disableOnInteraction: false
      }
    });
    // v0.2.0i.o 实战: 4 件套就够, 不需要 on.init slideToLoop 补丁
    //   之前试过 this.swiper.slideTo(0, 0) + on.init slideToLoop(0) 都被 swiper 11 loop normalize 覆盖
    //   实际 centeredSlides + loop 模式下:
    //     - DOM 顺序: [副本 (events[3]), events[0], events[1], events[2]]
    //     - activeIndex = 1, realIndex = 0
    //     - active slide (events[0]) 居中, x=17 width=356 在 viewport 内 ✅
    //     - mouse.click active slide photo → fancybox 弹 ✅
    //   注意: 测 photo 位置要查 .swiper-slide-active 里的 photo, 不是 DOM 第一个
    //     (DOM 第一个是 loop 副本, 永远在 viewport 左侧外)
  }

  // v0.1.30 改: 教练列表 swiper peek carousel (辉哥 11:08 反馈, 11:10 拍板 B 方案)
  //   - 经典 macOS App Store / iOS Music 风格: 1 张完整 + 0.2 张 peek
  //   - 复用 swiper 11 依赖 (v0.1.6 装 events 用), 跟 events section 同款 swiper pattern
  //   - 跟 this.swiper 独立 instance, onremove 各自 destroy
  initCoachSwiper(vnode) {
    if (!vnode || !vnode.dom) return;
    if (this.coachSwiper) this.coachSwiper.destroy(true, true);
    this.coachSwiper = new Swiper(vnode.dom, {
      // 不需要 Autoplay, 教练列表静态展示
      modules: [Navigation, Pagination],
      loop: true,
      // v0.2.0h 改: 显式分 3 段 viewport (辉哥 14:15 反馈, 跟 v0.1.38 768+ 跳 desktop 3 累计)
      //   mobile (< 768px) 1, tablet (768-1024) 2, desktop (>= 1024) 3
      //   swiper 11 breakpoints 触发 slidesPerView 切换, 跟 v0.1.30 swiper peek breakpoints 模式一致
      //   v0.1.38 改的 slidesPerView: 3 是 desktop 3 (768+ 跳 3), v0.2.0h 拆 tablet 2 + desktop 3
      slidesPerView: 1,
      spaceBetween: 16,
      breakpoints: {
        768: {
          // v0.2.0h: tablet 768-1024, 2 卡 (新加, 之前 v0.1.38 跳 3 视觉太挤)
          slidesPerView: 2
        },
        1024: {
          // v0.2.0h: desktop >= 1024, 3 卡 (跟 v0.1.38 行为不变, 显式分段)
          slidesPerView: 3
        }
      },
      pagination: {
        el: vnode.dom.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  }

  // 销毁 events swiper
  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  // 销毁教练 swiper
  // v0.1.30 改: 多 swiper instance, coach swiper 独立 destroy
  destroyCoachSwiper() {
    if (this.coachSwiper) {
      this.coachSwiper.destroy(true, true);
      this.coachSwiper = null;
    }
  }

  // v0.2.0ebb16a0.c.c 改 (辉哥 2026-09-05 00:52 反馈): 恢复 setupLevelObserver 方法 (Coder c.6 误删)
  //   现象: revert renderCurriculumSection 后引用 this.setupLevelObserver(dom), 但 Coder c.6 把这个方法替换成 inline oncreate
  //   修法: 恢复 setupLevelObserver 方法 (跟 ebb16a0 一致)
  //   配套: IntersectionObserver rootMargin '0px 0px -50% 0px' 让卡片进入 viewport 顶部 50% 才触发 --visible (高亮蓝边 + opacity 1)
  //   退出 viewport 顶部 50% 时移除 --visible, 视觉自然反向 (灰暗 + opacity 0.5)
  //   跟辉哥图 'Lv 1-2 高亮 + Lv 3-4 灰暗' 一致 (截屏时 Lv 1-2 在 viewport 顶部 50%, Lv 3-4 在 viewport 下方不可见)
  setupLevelObserver(dom) {
    if (!dom) return;
    if (dom._levelObserver) {
      dom._levelObserver.disconnect();
      dom._levelObserver = null;
    }
    const cards = dom.querySelectorAll('.bjxy-level-card');
    if (cards.length === 0) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('bjxy-level-card--visible');
        } else {
          entry.target.classList.remove('bjxy-level-card--visible');
        }
      });
    }, {
      rootMargin: '0px 0px -50% 0px',
      threshold: 0
    });
    cards.forEach(card => observer.observe(card));
    dom._levelObserver = observer;
  }

  // 组件销毁时清理
  // v0.1.30 改: 多 swiper instance, events + coach 各自 destroy
  // v0.2.0i.i 新: 同步移 body class (桌面端 sidebar 隐藏那个)
  //   切回 /d /u /all 等其他论坛路径时, sidebar 恢复 vendor 默认 (transform 折叠或展开)
  //   不移除 class 会导致其他页面 sidebar 永远 hidden
  // v0.2.0ebb16a0.c 改: 加 super.onremove(vnode) 调用 vendor Page 基类
  //   vendor Page.onremove L58-63 走 $('#app').removeClass(this.bodyClass) 移除 'App--index'
  //   不调 super 会导致 #app 一直有 'App--index' class, 切到 /d /u 等其他路径后污染
  onremove(vnode) {
    super.onremove(vnode);
    this.destroySwiper();
    this.destroyCoachSwiper();
    // v0.2.0i.n: 移 bjxy-page-active class + 兜底删老 <style id="bjxy-hide-mobile-tab"> 节点
    //   跟 oninit add bjxy-page-active 对应, 切回 /d /u /all 等路径时 body class 移除
    //   桌面端 sidebar 隐藏现在也挂在 bjxy-page-active 上 (v0.2.0ebb16a0.c.f.m.e.14), 一起被这个 remove 带走
    //   兜底删老节点: 兼容老 user 老 cache (deploy 前已经注入的 inline style 节点)
    if (typeof document !== 'undefined' && document.body) {
      // v0.2.0i.n: 移 page-level class
      document.body.classList.remove('bjxy-page-active');
      // v0.2.0i.n: 兜底删老 inline style 节点 (双保险, 兼容老 user 老 cache)
      const oldStyle = document.getElementById('bjxy-hide-mobile-tab');
      if (oldStyle) oldStyle.remove();
    }
    // v0.2.0i.k.b.6 改: 不清 sessionStorage bjxy active flag
    //   之前 v0.2.0i.k.b.3 设计是 onremove 清 active='0', 但这跟"刷新场景补 push"冲突
    //   实际场景:
    //     - bjxy → /u/wfl (SPA 内): 劫持同步 push bjxy, 然后 bjxy onremove 触发
    //       如果 onremove 清 active='0', 立即 page.reload 刷新 /u/wfl:
    //         setTimeout 0 check active='0' → 不补 push → 走 vendor 默认 back '/' 错误
    //     - bjxy → /d/1 → /u/wfl (SPA 内): 劫持 check app.previous 三重 check, 不依赖 active
    //       即使不清 active, app.previous='discussion' 也不会 push bjxy ✅
    //   结论: 不清 active, 严格依赖 app.previous 三重 check 修副作用
    //   风险: 用户在 bjxy → /d/1 → /u/wfl, sessionStorage active='1' 还在, 但劫持只 check app.previous='discussion', 不 push ✅
    //   好处: 刷新 /u/wfl 场景, sessionStorage active='1', setTimeout 0 fresh load 路径补 push ✅
  }

  // v0.2.0ebb16a0.c 改: view() 走 vendor PageStructure (跟 vendor IndexPage.view() 一样模式)
  //   vendor IndexPage.tsx L64-70 走 <PageStructure className="IndexPage" hero={...} sidebar={...}>{contentItems()}</PageStructure>
  //   走 vendor 4 层容器: <div class="Page IndexPage"> > Page-pane + Page-main(id="page-main") > Page-hero + Page-container > Page-sidebar + Page-content(id="main-content")
  //   跟 /all 1:1 一致 DOM 结构
  //   删除 c.20 段: <ul class="bjxy-mobile-cta-ul"> 内 <li> + <button> 段 (走 vendor IndexSidebar 自动渲染)
  // v0.2.0ebb16a0.c.f 改 (辉哥 2026-09-05 01:22 反馈): 恢复 bjxy-page-bg 视差背景 div + 4 色 linear-gradient + 蓝/紫光斑
  //   现象: 辉哥反馈"bjxy 后台设置的背景起始色和结束色, 前端好像没有生效"
  //   根因: Coder c.6 改 PageStructure 模板时, 删了 .bjxy-page-bg 视差背景 div + 4 色 linear-gradient 渲染 + 蓝/紫光斑装饰
  //     - 走 vendor PageStructure 4 层容器, 4 色背景色 setting 失效
  //     - 玻璃拟态蓝/紫光斑装饰也失效
  //     - 视差滚动 backgroundPositionY 监听也失效
  // v0.2.0ebb16a0.c.f.e 改 (辉哥 2026-09-05 01:56 反馈): 修 2 个 bug
  //   Bug 1: 背景不是渐变 (c.f.d 改 2 段硬切错了) → 改回 4 色平滑 (ls→le→ds→de), dark 模式顶部用 ds 替换 ls
  //     公式: `linear-gradient(180deg, ${c1} 0%, ${c2} 50%, ${c3} 50%, ${c4} 100%)` 4 色平滑 (c1→c2→c3→c4 一路过渡)
  //     light: c1=ls, c2=le, c3=ds, c4=de → 浅蓝白 → 浅白 → 深蓝 → 深色 (4 色平滑)
  //     dark: c1=ds, c2=ds, c3=de, c4=de (默认 bjxy.top 实际走 dark) → 深蓝 → 深蓝 → 深红 → 深红 (视觉: 顶部一片深蓝, 中间渐变到深红, 底部一片深红)
  //     数据库实际 bjxy_bg_gradient_dark_start = '#0F1419' (fallback), bjxy_bg_gradient_dark_end = '#831100' (9/5 改)
  //   Bug 2: 每个 section 文字被 bjxy-page-bg 盖住 (c.f.c 改 pane slot 错了)
  //     根因: c.f.c 把 bjxy-page-bg 走 vendor PageStructure pane slot, bjxy-page-bg position: fixed + z-index: 0 在 Page-pane 内部
  //       z-index: 0 + position: fixed 创建 stacking context, 跟兄弟 Page-main (z-index: auto) 比较, z-index: 0 > auto, bjxy-page-bg 在 Page-main 之上
  //       → bjxy-page-bg 4 色背景覆盖 Page-main 内容 (hero + 8 section 都被它盖住)
  //     修法: bjxy-page-bg 回到 main 内部 children 第一位 (跟 c.f 时代 view() 数组一样) + z-index: auto (不创建 stacking context)
  //       z-index: auto + position: fixed 不创建 stacking context, 跟 Page.IndexPage (z-index: auto) 兄弟比较, 都 auto 不创建 stacking context
  //       按 DOM 顺序叠加: bjxy-page-bg 在前 (底层), Page.IndexPage 在后 (叠加在 bjxy-page-bg 之上, section 文字浮在 4 色背景上面)
  //       + main.App-content transparent (让 bjxy-page-bg 4 色显示)
  //     实战教训 (SOP 329 续):
  //       - z-index: 0 + position: fixed → 创建 stacking context, 在兄弟 z-index: auto 之上, **会盖住内容**
  //       - z-index: auto + position: fixed → 不创建 stacking context, 按 DOM 顺序叠加, **不盖内容**
  //       - z-index: -1 → 跑出 stacking context 落到 body 背景后
  //       - 走 vendor stacking context 父链时, 选 z-index: auto + position: fixed + DOM 顺序 = 最稳
  // v0.2.0ebb16a0.c.f.m.d 改 (辉哥 2026-09-05 12:03 反馈 "光斑现在都在右侧, 光斑的位置能不能随机性强一些"):
  //   根因: c.f.m.c 4 radial 4 角规则位置 (左上 20% 15% / 右上 80% 25% / 左下 25% 80% / 右下 80% 90%) 太对称, 看起来像固定装饰而不是自然光斑
  //     右上 (80%) + 右下 (80%) X 坐标都在右侧, 加之 35% transparent 半径使右侧 de 红光斑覆盖面积明显大于左侧 ds
  //     → 视觉上"光斑都在右侧" (辉哥 12:03 反馈)
  //   修法: 4 radial → 6 radial, 位置打破 4 角对称, X 坐标在 10%-90% 范围分散, 颜色 ds/de 3+3 交错
  //   6 个光斑位置 (辉哥 12:03 拍板"随机性强", 6 个位置避免视觉对称):
  //     1. (10% 12%) ${ds}: 左上偏远 (深蓝基调)
  //     2. (45% 8%) ${de}: 顶部中央偏左 (深红点缀)
  //     3. (78% 22%) ${ds}: 右上偏远 (深蓝基调, 跟 2 形成 ds/de 上下相邻对比)
  //     4. (15% 55%) ${de}: 左侧中央偏上 (深红, 跟 5 形成上下相邻对比)
  //     5. (60% 48%) ${ds}: 中央偏右 (深蓝, 跟 4 + 6 形成颜色交错)
  //     6. (88% 82%) ${de}: 右下偏远 (深红, 跟 bjxy 自建 footer 顶部 de 红衔接)
  //   颜色: 3 ds + 3 de 交错 (位置打破 4 角对称 + 颜色打破上下分组)
  //   视差 0.02x + background-size 100% 300vh 保留
  //   ::before 蓝/::after 紫光斑保留 (decorative glass morphism)
  //   实战教训 (c.f.m.d): 4 radial 即使颜色交错, 位置 4 角对称仍有"固定装饰"感
  //     - 6 radial 位置分散在 viewport 不同角落, 视觉上是"自然光斑"而不是"固定装饰"
  //     - 颜色 3+3 交错 (不是 2+2 配对) → 视觉上看不出颜色规律
  //     - X 坐标避免 4 角对称 (20%/80% 是对称, 改成 10%/45%/78%/15%/60%/88% 不规则分布)
  view() {
    // v0.2.0ebb16a0.c.f.m.d 改: 读 2 色背景色 setting (ds + de) + 2 张背景图 setting (走 ziven-core COS 上传)
    //   ls/le 还在 (footer / page-content section alt 等其他位置仍用), 但光斑**不**引用 ls/le
    const s = (key, fallback) => app.forum.attribute(key) || fallback;
    const ls = s('bjxy_bg_gradient_light_start', '#E0EBF8') || '#E0EBF8';
    const le = s('bjxy_bg_gradient_light_end', '#F7FAFC') || '#F7FAFC';
    const ds = s('bjxy_bg_gradient_dark_start', '#0F1419') || '#0F1419';
    const de = s('bjxy_bg_gradient_dark_end', '#1A202C') || '#1A202C';
    const imgLight = s('bjxy_bg_image_light_url', '');
    const imgDark = s('bjxy_bg_image_dark_url', '');
    // v0.2.0ebb16a0.c.f.m.d 改: 6 radial gradient 光斑位置随机分散 (辉哥 12:03 反馈 c.f.m.c 光斑都在右侧)
    //   6 个 radial-gradient 在 background-image 用逗号叠加
    //   6 角分散位置 (打破 4 角对称): 10% 12%, 45% 8%, 78% 22%, 15% 55%, 60% 48%, 88% 82%
    //   颜色 3 ds + 3 de 交错 (打破上下分组): ds, de, ds, de, ds, de
    //   视觉: 6 个分散光斑, 位置不规则 + 颜色交错, 像自然光斑不是固定装饰
    //   底色: light 模式 le / dark 模式 ds 兜底 transparent 区域
    //   有图走 background: url() 覆盖
    const buildRadialBg = isDark => {
      const base = isDark ? ds : le;
      return [`radial-gradient(circle at 10% 12%, ${ds} 0%, transparent 32%)`, `radial-gradient(circle at 45% 8%, ${de} 0%, transparent 30%)`, `radial-gradient(circle at 78% 22%, ${ds} 0%, transparent 32%)`, `radial-gradient(circle at 15% 55%, ${de} 0%, transparent 30%)`, `radial-gradient(circle at 60% 48%, ${ds} 0%, transparent 32%)`, `radial-gradient(circle at 88% 82%, ${de} 0%, transparent 30%)`, base].join(', ');
    };
    const bjxyPageBg = m('div', {
      class: 'bjxy-page-bg',
      key: 'bjxy-page-bg',
      oncreate: _ref => {
        let {
          dom
        } = _ref;
        // v0.2.0ebb16a0.c.f.m 改: 4 radial gradient 光斑 + 主题联动
        const isDark = document.body.getAttribute('data-theme')?.startsWith('dark') || document.documentElement.getAttribute('data-theme')?.startsWith('dark');
        if (imgLight || imgDark) {
          // v0.1.0z: 有图走 background: url(), 没图走 4 radial 光斑
          const urls = [imgLight, imgDark].filter(Boolean);
          dom.style.background = urls.length > 0 ? `url(${urls[0]}) center/cover no-repeat` : buildRadialBg(isDark);
        } else {
          // v0.2.0ebb16a0.c.f.m 改: 4 radial gradient 光斑 (替代 c.f.e 4 色 linear)
          dom.style.background = buildRadialBg(isDark);
        }
        // v0.1.0aa: 渐变图 background-size 100% 300vh (比 viewport 大 3 倍)
        //   视差 0.02x scrollY (v0.2.0ebb16a0.c.f.k 改, 辉哥 9/5 10:40 反馈 "动效渐弱一些") 让背景从 div 顶部往上推 (Y 变成负值)
        //   修法史: 0.1x (c.f.g) → 0.05x (c.f.h, 减半) → 0.02x (c.f.k, 再减 60%)
        //   4 radial gradient 时代, 视差动效保留 (scroll 时 backgroundPositionY 仍变化), 光斑位置微微浮动, 增强 glass morphism 玻璃感
        this._bgParallax = () => {
          const offset = window.scrollY * 0.00;
          dom.style.backgroundPositionY = `calc(0px - ${offset}px)`;
        };
        window.addEventListener('scroll', this._bgParallax, {
          passive: true
        });
        this._bgParallax();
      },
      onremove: () => {
        if (this._bgParallax) {
          window.removeEventListener('scroll', this._bgParallax);
          this._bgParallax = null;
        }
      }
    });
    // v0.2.0ebb16a0.c.f.e 改: bjxy-page-bg 走 main 内部 children 第一位 (跟 c.f 时代 view() 数组一样)
    //   + PageStructure 用 pane={() => null} (不用 pane slot, 避免 z-index 父链问题)
    //   DOM 顺序: main.App-content > [bjxy-page-bg (auto, fixed), PageStructure 渲染的 Page.IndexPage (auto)]
    //   两个都 z-index: auto, 不创建 stacking context, 按 DOM 顺序叠加: bjxy-page-bg 在前底层, Page.IndexPage 在后叠加在上面
    return [bjxyPageBg, m(PageStructure, {
      key: "page-structure",
      className: "IndexPage",
      hero: this.hero.bind(this),
      sidebar: this.sidebar.bind(this)
    }, this.contentItems())];
  }

  // v0.2.0ebb16a0.c 改: hero() 走 vendor Page-hero slot, full-width 100vw
  //   vendor PageStructure.providedHero() L99-101 走 <div class="Page-hero">{(hero && hero()) || null}</div>
  //   bjxy hero 渲染函数保留 (跟 c.20 段一致, 改 .bjxy-hero 段走 100% width 不设 max-width)
  hero() {
    return this.renderHeroSection((key, fallback) => app.forum.attribute(key) || fallback);
  }

  // v0.2.0ebb16a0.c 改: contentItems() 走 vendor Page-content slot, 700px 容器
  //   vendor PageStructure.providedContent() L103-108 走 <div class="Page-content" id="main-content">{content}</div>
  //   vendor PageStructure.less L43-45 @media @phone, @tablet { .Page-content { margin-top: 15px } } (mobile/tablet 100% width)
  //   vendor PageStructure.less L7 .Page-content { width: var(--content-width) } (.Page--cols 段, desktop 100%)
  //   vendor 实际 8 section 走 Page-content, content-width = 100% (mobile/tablet) 或 flex 1 (desktop)
  //   8 section max-width 1280px → 100% (less 段改, 跟 Page-content 自适应)
  contentItems() {
    const s = (key, fallback) => app.forum.attribute(key) || fallback;
    // v0.1.0s 改: curriculum 从 {single, double} 重构成 boards array
    //   兼容旧 data: 如果没 boards 字段但有 single/double, 自动转成 2 个 board
    const curriculumRaw = app.data && app.data.bjxyCurriculum || {};
    const curriculum = {
      boards: Array.isArray(curriculumRaw.boards) ? curriculumRaw.boards : [{
        name: '单板',
        levels: curriculumRaw.single || []
      }, {
        name: '双板',
        levels: curriculumRaw.double || []
      }]
    };
    const features = app.data && app.data.bjxyFeatures || [];
    // v0.1.6e 改: 过滤空 desc 的特色项, 避免 6+1 布局不平衡 (移动端 2 列变 3+3+1 孤零零)
    //   辉哥 14:04 反馈 "后台办学特色中的内容在移动端右侧出视界了"
    //   根因: 后台"添加特色"按钮会 push 一个空 desc 的占位项, 用户没填就保存, 布局不齐
    //   修法: 前端过滤 title 或 desc 为空的项, 不渲染; 6 项默认 = 桌面 2 行 3 列 + 移动 3 行 2 列 (整齐)
    const visibleFeatures = features.filter(f => f && f.title && f.desc);
    // v0.1.7a 改: 删 bjxy_reviews_html + bjxy_students_html fallback 读取
    //   老的 HTML 自由区字段已经废弃, 评价/活动统一用结构化 JSON
    // v0.1.6: 评价 + 学员结构化 JSON (替代 HTML 自由区)
    //   app.forum.attribute 拿 string, JSON.parse 转 array
    const reviews = (() => {
      const raw = s('bjxy_reviews', '[]');
      if (!raw) return [];
      try {
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    })();
    // v0.1.6a: 学员 → 活动 (仍读 bjxy_students setting, 但展示为"活动")
    const events = (() => {
      const raw = s('bjxy_students', '[]');
      if (!raw) return [];
      try {
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr : [];
      } catch (e) {
        return [];
      }
    })();

    // v0.2.0ebb16a0.c 改: 返回 7 主体 section + footer (走 Page-content slot)
    //   走 vendor Page-content slot, 接受 700px 容器 trade-off
    //   跟 c.20 段一致: renderSectionByKey 按 order 渲染 7 主体 section (hero 改走 this.hero() 单独渲染, 不在 contentItems)
    //   加 footer 段 (v0.1.0ab 起 footer 永远最底, 不参与排序, 走 isSectionVisible('footer') 控制)
    //   footer 走 Page-content 内部, 跟 /all footer 在 Page-content 一致, 但 /all footer 是 vendor App-footer (走 bjxy less 隐藏), bjxy footer 是自定义
    //   ⚠️ 过滤 null: getSectionOrder 中 'hero' case 改返 null (走 this.hero() 单独渲染), 数组中混 null + keyed vnode 触发 mithril "In fragments, vnodes must either all have keys or none have keys" TypeError
    //   修法: .filter(Boolean) 过滤 null/undefined, 数组中只剩 keyed vnode
    const sections = this.getSectionOrder().map(k => this.renderSectionByKey(k, {
      s,
      events,
      reviews,
      visibleFeatures,
      curriculum
    })).filter(Boolean);
    if (this.isSectionVisible('footer')) {
      // v0.1.0ab 改: 备案号从 bjxy_icp_number setting 读 (后台可设)
      //   留空时 fallback 到默认 '2026xxxxxx' (跟之前 hard-coded 一致, 兼容旧部署)
      // v0.1.2 改: 加 公安备案号 + 网安链接 (国家规定中国大陆站点 footer 必须有)
      //   留空时不渲染公安备案行 (避免显示空链接)
      // v0.1.15 改: 走 isSectionVisible('footer') 判断, 关闭时不渲染整个 footer
      const brandName = s('bjxy_brand_name', DEFAULT_BRAND);
      const icpNumber = s('bjxy_icp_number', '2026xxxxxx') || '2026xxxxxx';
      const policeNumber = s('bjxy_police_number', '');
      const policeLink = s('bjxy_police_link', 'http://www.beian.gov.cn/portal/registerSystemInfo') || 'http://www.beian.gov.cn/portal/registerSystemInfo';
      sections.push(m('footer', {
        class: 'bjxy-footer',
        key: 'bjxy-footer'
      }, [m('div', {
        class: 'bjxy-footer-line'
      }, '© ' + new Date().getFullYear() + ' ' + brandName + ' · ICP 备 ' + icpNumber + ' 号'), policeNumber ? m('div', {
        class: 'bjxy-footer-line'
      }, [m('img', {
        class: 'bjxy-footer-police-icon',
        src: 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="14" height="14"><path fill="#fff" d="M10 1l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V4l8-3zm0 2.2L4 5.4V10c0 4 2.7 6.8 6 7.3 3.3-.5 6-3.3 6-7.3V5.4l-6-2.2zM7 8h6v1H7V8zm0 2h6v1H7v-1zm0 2h4v1H7v-1z"/></svg>'),
        alt: '公安备案'
      }), ' ', m('a', {
        href: policeLink,
        target: '_blank',
        rel: 'noopener noreferrer',
        class: 'bjxy-footer-link'
      }, '京公网安备 ' + policeNumber + ' 号')]) : null]));
    }
    return sections;
  }

  // v0.2.0ebb16a0.c 改: sidebar() 走 vendor Page-sidebar slot, 走 bjxy 自定义 BjxySidebar
  //   vendor PageStructure.sidebarItems() L83-89 走 <div class="Page-sidebar">{this.attrs.sidebar() || null}</div>
  //   vendor PageStructure.container() L79-81 走 <div class="Page-container container">{containerItems}</div>
  //   vendor PageStructure.containerItems() L70-77 items.add('sidebar', this.sidebar(), 100) + content
  //   bjxy 自定义 BjxySidebar 走 vendor IndexSidebar 模板, 替换 newDiscussion.onclick 弹 BookingModal
  //   跟 /all 1:1 DOM 结构: <nav class="IndexPage-nav sideNav"> > <ul> > <li.item-newDiscussion.App-primaryControl> > <button.IndexPage-newDiscussion>
  sidebar() {
    return m(BjxySidebar, null);
  }

  // v0.1.9: 读 bjxy_section_order_json 解析成数组, 过滤掉 brand/bg/footer
  //   防御: 解析失败 / 不是数组 / 数组里 key 不对时 fallback 到默认顺序
  // v0.1.15 改: 额外过滤掉 visible=false 的 section (走 bjxy_section_visible_<key> setting)
  //   辉哥 18:19 拍板: "只有在开启时前端对应的section才展示"
  //   footer 单独判断 (走 isSectionVisible('footer') 控制, 不参与主 section 列表)
  getSectionOrder() {
    const DEFAULT_SECTION_ORDER = ['hero', 'about', 'events', 'features', 'curriculum', 'coach', 'reviews', 'contact'];
    const raw = app.forum.attribute('bjxy_section_order_json');
    if (!raw) return DEFAULT_SECTION_ORDER.filter(k => this.isSectionVisible(k));
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        // 过滤掉 brand / bg / footer (这 3 个不渲染独立 section) + visible=false 的
        const mainSections = parsed.filter(k => k !== 'brand' && k !== 'bg' && k !== 'footer').filter(k => this.isSectionVisible(k));
        // 验证剩下 8 个主体 section key 都有
        if (mainSections.length === DEFAULT_SECTION_ORDER.filter(k => this.isSectionVisible(k)).length) {
          const validKeys = DEFAULT_SECTION_ORDER;
          const allValid = mainSections.every(k => validKeys.indexOf(k) >= 0);
          if (allValid) return mainSections;
        }
      }
    } catch (e) {}
    return DEFAULT_SECTION_ORDER.filter(k => this.isSectionVisible(k));
  }

  // v0.1.15: 判断 section 是否可见 (读 bjxy_section_visible_<key> setting)
  //   默认 true (旧部署缺 setting 时全部展示, 跟开关默认开启一致)
  //   '1' / 'true' / true 算可见; 其他 (含 '0' / 'false' / 缺省) 算可见 (默认)
  isSectionVisible(key) {
    const v = app.forum.attribute('bjxy_section_visible_' + key);
    if (v === '0' || v === 'false' || v === false) return false;
    return true; // 默认可见 (跟 oninit 默认一致, 兼容旧部署)
  }

  // v0.1.9: 按 key 调用对应 renderXxxSection 方法
  //   跟 v0.1.6b 沉淀的 section class 一致: hero/约/features/curriculum 走 alt, 其他走 normal
  //   保留 v0.1.6b section 顺序: about(events 移走) → events 跟 alt 交替
  //   hero 是 page 顶部特殊 section (跟其他 section 视觉差异大), 不走 bjxy-section/bjxy-section-alt
  //   v0.2.0ebb16a0.c 改: hero 段走 vendor Page-hero slot (this.hero() 方法), 不在 contentItems 渲染
  //     renderSectionByKey 移除 'hero' case (改走 this.hero() 单独渲染)
  renderSectionByKey(key, ctx) {
    const {
      s,
      events,
      reviews,
      visibleFeatures,
      curriculum
    } = ctx;
    switch (key) {
      case 'hero':
        return null;
      // v0.2.0ebb16a0.c 改: hero 走 this.hero() 单独渲染
      case 'about':
        return this.renderAboutSection(s);
      case 'events':
        return this.renderEventsSection(events, s);
      // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): 3 个 renderSection 都加 s 参数 (s() helper 用来读 bjxy_section_label_*)
      case 'features':
        return this.renderFeaturesSection(visibleFeatures, s);
      case 'curriculum':
        return this.renderCurriculumSection(curriculum, s);
      case 'coach':
        return this.renderCoachSection(s);
      case 'reviews':
        return this.renderReviewsSection(reviews, s);
      case 'contact':
        return this.renderContactSection(s);
      default:
        return null;
    }
  }

  // v0.1.9: 8 主体 section 渲染方法 (从 view() 提取)
  //   每个方法返回 1 个 m() 节点, 跟 v0.1.6b 沉淀的 HTML 结构 1:1 一致

  // Hero
  // v0.2.0ebb16a0.c 改: hero 走 vendor Page-hero slot, .bjxy-hero 改 100% width
  //   vendor PageStructure.providedHero() <div class="Page-hero">{hero()}</div>
  //   vendor 不限制 Page-hero 宽度, 默认 100vw
  //   bjxy hero 内部 grid 1.2fr 1fr 改 width: 100% 适配 Page-hero
  renderHeroSection(s) {
    return m('section', {
      class: 'bjxy-hero',
      id: 'hero',
      key: 'sec-hero'
    }, [m('div', {
      class: 'bjxy-hero-text'
    }, [m('h1', null, [s('bjxy_hero_title', '探索极致的滑雪体验。')]), m('p', null, s('bjxy_hero_subtitle', '专注滑雪领域的全国连锁机构, 17 级渐进教学体系 + 认证教练 + 全国品牌机构。')), m('div', {
      class: 'bjxy-hero-features'
    }, [m('div', {
      class: 'bjxy-hero-feature'
    }, [m('span', {
      class: 'check'
    }, '✓'), m('strong', null, s('bjxy_about_stat_1_num', '10+')), ' ' + s('bjxy_about_stat_1_label', '年教学经验')]), m('div', {
      class: 'bjxy-hero-feature'
    }, [m('span', {
      class: 'check'
    }, '✓'), m('strong', null, s('bjxy_about_stat_2_num', '50+')), ' ' + s('bjxy_about_stat_2_label', '专业教练')]), m('div', {
      class: 'bjxy-hero-feature'
    }, [m('span', {
      class: 'check'
    }, '✓'), m('strong', null, s('bjxy_about_stat_3_num', '1000+')), ' ' + s('bjxy_about_stat_3_label', '毕业学员')])])]), m('div', {
      class: 'bjxy-hero-banner'
    }, [s('bjxy_hero_banner_light') ? m('img', {
      class: 'bjxy-hero-banner-light',
      src: s('bjxy_hero_banner_light'),
      alt: 'Hero'
    }) : null, s('bjxy_hero_banner_dark') ? m('img', {
      class: 'bjxy-hero-banner-dark',
      src: s('bjxy_hero_banner_dark'),
      alt: 'Hero Dark'
    }) : null, !s('bjxy_hero_banner_light') && !s('bjxy_hero_banner_dark') ? m('div', {
      class: 'bjxy-hero-banner-fallback'
    }, [m('div', {
      class: 'bjxy-hero-banner-fallback-name'
    }, s('bjxy_brand_name', DEFAULT_BRAND)), m('div', {
      class: 'bjxy-hero-banner-fallback-slogan'
    }, s('bjxy_brand_slogan', DEFAULT_SLOGAN))]) : null])]);
  }

  // 关于
  renderAboutSection(s) {
    return m('section', {
      class: 'bjxy-section',
      id: 'about',
      key: 'sec-about',
      style: 'padding: 32px 0px;'
    }, [m('div', {
      class: 'bjxy-sub'
    }, s('bjxy_about_sub', 'ABOUT US')),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_about, 跟后台 '关于我们' tab 联动
    //   之前用 bjxy_about_title 单独字段, 现在统一走 bjxy_section_label_<key> 跟其他 5 个 section 一致
    m('h2', null, s('bjxy_section_label_about', '关于北极雪屿')),
    // v0.2.0d (辉哥 11:55 反馈): bjxy_about_desc 支持 HTML 渲染
    // admin 走 textareaField (不变, 支持输入 HTML), 前端用 m.trust() 渲染 HTML
    // 改 <p> → <div> 是因为 m.trust 可能包含多行 HTML (h1/h2/ul 等), p 不能嵌套块级元素
    // 加 .bjxy-about-desc class 方便 less 调样式 + XSS 防护走 admin 权限 (有 bjxy_about_desc 字段写入权限的人 = admin user)
    m('div', {
      class: 'bjxy-about-desc'
    }, m.trust(s('bjxy_about_desc', '北极雪屿室内滑雪成立于 2024 年, 专注滑雪领域的全国连锁机构...'))), m('div', {
      class: 'bjxy-stats'
    }, [m('div', {
      class: 'bjxy-stat'
    }, [m('div', {
      class: 'bjxy-stat-num'
    }, s('bjxy_about_stat_1_num', '10+')), m('div', {
      class: 'bjxy-stat-label'
    }, s('bjxy_about_stat_1_label', '年教学经验'))]), m('div', {
      class: 'bjxy-stat'
    }, [m('div', {
      class: 'bjxy-stat-num'
    }, s('bjxy_about_stat_2_num', '50+')), m('div', {
      class: 'bjxy-stat-label'
    }, s('bjxy_about_stat_2_label', '专业教练'))]), m('div', {
      class: 'bjxy-stat'
    }, [m('div', {
      class: 'bjxy-stat-num'
    }, s('bjxy_about_stat_3_num', '1000+')), m('div', {
      class: 'bjxy-stat-label'
    }, s('bjxy_about_stat_3_label', '毕业学员'))])])]);
  }

  // 活动展示
  // v0.1.6b 改: 从尾部移到关于下方 (v0.1.9 现在按 order 决定位置)
  // v0.1.6d: 活动展示支持点击跳转 URL
  renderEventsSection(events, s) {
    return m('section', {
      class: 'bjxy-section bjxy-section-alt',
      id: 'events',
      key: 'sec-events'
    }, [m('div', {
      class: 'bjxy-sub'
    }, 'EVENTS'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_events, 跟后台 '活动展示' tab 联动
    m('h2', null, s('bjxy_section_label_events', '活动展示')), events.length > 0 ? m('div', {
      class: 'bjxy-event-swiper swiper',
      oncreate: vnode => this.initSwiper(vnode)
    }, [m('div', {
      class: 'swiper-wrapper'
    }, events.map((ev, i) => {
      const photos = Array.isArray(ev.photos) ? ev.photos : ev.photoUrl ? [ev.photoUrl] : [];
      const firstPhoto = photos[0];
      const url = (ev.url || '').trim();
      const isInternal = url.startsWith('/') && !url.startsWith('//');
      const hasUrl = url.length > 0;
      return m('div', {
        class: 'swiper-slide bjxy-event-slide',
        key: 'ev' + i
      }, [firstPhoto ? hasUrl ? isInternal ? m('a', {
        class: 'bjxy-event-photo',
        style: {
          backgroundImage: 'url(' + firstPhoto + ')'
        },
        href: url,
        onclick: e => {
          e.preventDefault();
          m.route.set(url);
        }
      }) : m('a', {
        class: 'bjxy-event-photo',
        style: {
          backgroundImage: 'url(' + firstPhoto + ')'
        },
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer'
      }) : m('a', {
        class: 'bjxy-event-photo',
        style: {
          backgroundImage: 'url(' + firstPhoto + ')'
        },
        onclick: e => {
          e.preventDefault();
          this.openFancyboxGallery(photos, 0);
        }
      }) : m('div', {
        class: 'bjxy-event-photo bjxy-event-photo-empty'
      }), hasUrl ? isInternal ? m('a', {
        class: 'bjxy-event-info bjxy-event-link',
        href: url,
        onclick: e => {
          e.preventDefault();
          m.route.set(url);
        }
      }, [m('div', {
        class: 'bjxy-event-name'
      }, ev.name || '活动 #' + (i + 1)), ev.level ? m('div', {
        class: 'bjxy-event-level'
      }, ev.level) : null, ev.achievement ? m('div', {
        class: 'bjxy-event-desc'
      }, ev.achievement) : null, photos.length > 1 ? m('div', {
        class: 'bjxy-event-photo-count'
      }, '📷 ' + photos.length + ' 张, 点击查看全部') : null]) : m('a', {
        class: 'bjxy-event-info bjxy-event-link',
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer'
      }, [m('div', {
        class: 'bjxy-event-name'
      }, ev.name || '活动 #' + (i + 1)), ev.level ? m('div', {
        class: 'bjxy-event-level'
      }, ev.level) : null, ev.achievement ? m('div', {
        class: 'bjxy-event-desc'
      }, ev.achievement) : null, photos.length > 1 ? m('div', {
        class: 'bjxy-event-photo-count'
      }, '📷 ' + photos.length + ' 张, 点击查看全部') : null]) : m('div', {
        class: 'bjxy-event-info'
      }, [m('div', {
        class: 'bjxy-event-name'
      }, ev.name || '活动 #' + (i + 1)), ev.level ? m('div', {
        class: 'bjxy-event-level'
      }, ev.level) : null, ev.achievement ? m('div', {
        class: 'bjxy-event-desc'
      }, ev.achievement) : null, photos.length > 1 ? m('div', {
        class: 'bjxy-event-photo-count'
      }, '📷 ' + photos.length + ' 张, 点击查看全部') : null])]);
    })), m('div', {
      class: 'swiper-pagination'
    })]) : m('div', {
      class: 'bjxy-empty'
    }, '暂无活动')]);
  }

  // 办学特色
  // v0.1.6b 改: 段名称 "办学特色" (辉哥 15:20 拍板)
  // v0.1.6h 改: 玻璃拟态风格 (辉哥 16:06 拍板 A 方案)
  // v0.2.0ebb16a0.c.a 改 (辉哥 2026-09-05 00:38 反馈): revert Coder c.6 改坏的 5 处 features section
  //   现象: 辉哥反馈"办学特色 section 内容被回滚到之前版本", 截图标的目标样子
  //   根因: Coder c.6 改写 BjxyPage.jsx 走 vendor PageStructure 时, 顺手改了 renderFeaturesSection 5 处:
  //     1. 顶部小标题 'Why Choose Us' → 'WHY US' (字面值错)
  //     2. 主标题 fallback '办学特色' → '为什么选择北极雪屿' (字面值错)
  //     3. 副标题 hardcode '从环境到教练...' → 走 setting fallback '专注滑雪领域的全国连锁机构...' (走 setting 后后台没设, fallback 跟辉哥图不一致)
  //     4. 背景图字段 f.bgImageUrl → f.bg (字段不存在, **所有卡片无图**)
  //     5. 遮罩 opacity 走 setting → hardcode 无 style (遮罩透明度丢失)
  //   修法: revert 这 5 处, 恢复 ebb16a0 时代行为
  //   配套: 顶部小标题 'Why Choose Us' → 'WHY CHOOSE US' (辉哥图 UPPER, 跟 ebb16a0 Title case 略不同)
  //   配套: 数据库 bjxy_features_json 第 6 项 "学玩用赛" 改 "学玩用费" (辉哥图跟数据库不一致)
  renderFeaturesSection(visibleFeatures, s) {
    const overlayOpacity = parseInt(app.forum.attribute('bjxy_feature_card_overlay_opacity') || '50', 10) / 100;
    return m('section', {
      class: 'bjxy-section bjxy-section-alt bjxy-features-glass',
      id: 'features',
      key: 'sec-features',
      style: 'padding: 32px 0px;'
    }, [m('div', {
      class: 'bjxy-section-head'
    }, [m('div', {
      class: 'bjxy-features-eyebrow'
    }, 'WHY CHOOSE US'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_features
    //   之前是 hardcode '为什么选择北极雪屿' 跟后台 '办学特色' tab 不一致, 现在同步
    m('h2', null, s('bjxy_section_label_features', '办学特色')), m('p', {
      class: 'bjxy-features-sub'
    }, '从环境到教练, 从课程到装备, 每一个细节都为你精心准备')]), m('div', {
      class: 'bjxy-feature-grid'
    }, visibleFeatures.map((f, i) => m('div', {
      class: 'bjxy-feature' + (i < 2 ? ' bjxy-feature-large' : ''),
      key: 'f' + i
    }, [
    // v0.1.33 改: 背景图 (可选) + 黑色遮罩层 (opacity 走 setting)
    f.bgImageUrl ? m('div', {
      class: 'bjxy-feature-bg'
    }, [m('img', {
      src: f.bgImageUrl,
      alt: ''
    }), m('div', {
      class: 'bjxy-feature-mask',
      style: 'opacity: ' + overlayOpacity
    })]) : null, m('div', {
      class: 'bjxy-feature-content'
    }, [
    // v0.1.35 删: 数字编号 01-06 span (辉哥 17:12 反馈去掉每个卡片的数字编号)
    // v0.1.36 删: bjxy-feature-icon 渲染 (辉哥 21:52 反馈去掉 feature icon)
    //   后台 BjxySettings.jsx 也删了 icon 输入字段, less 也删了 .bjxy-feature-icon 整段 + ::after + 大卡 reset + mobile 段 reset + 有 bg 白字
    //   f.icon 字段 data schema 保留 (兼容老数据, 序列化 L1150 / 反序列化 L1535 不动)
    m('h3', null, f.title || ''), m('p', null, f.desc || '')])])))]);
  }

  // 教学体系
  // v0.1.0s 改: curriculum 从 {single, double} 重构成 boards array
  //   默认 2 个 board (单板 + 双板), 未来可加 multi-board
  // v0.1.0u 改: tabs 水平排列, 默认 active=0 (单板)
  // v0.2.0ebb16a0.c.c 改 (辉哥 2026-09-05 00:52 反馈): revert Coder c.6 改坏的 5 处 curriculum section
  //   现象: 辉哥发 curriculum 段目标图 (CURRICULUM eyebrow + 等级标准 h2 + 单板 (9 级) tab + Lv 1-4 卡片 + 1-2 高亮 + 3-4 灰暗)
  //   根因: Coder c.6 改 PageStructure 模板时, 顺手改了 renderCurriculumSection 5 处:
  //     1. class 删 bjxy-section-alt (改 background, 视觉错)
  //     2. h2 fallback hardcode '17 级渐进教学体系' (vs ebb16a0 动态 reduce 计算 boards 总级数)
  //     3. tab 改 div → button + 加 m.redraw (vs ebb16a0 div + 自动 re-render, button 改样式失效)
  //     4. tab 文字 '单板 (9 级)' → '单板' (vs ebb16a0 加 levels.length 后缀, 跟辉哥图 '单板 (9 级)' 不一致)
  //     5. 卡片右上角数字 'Lv N' → '#0N' (vs ebb16a0 'Lv N', 跟辉哥图 'Lv 1/Lv 2/Lv 3/Lv 4' 不一致)
  //   修法: revert 整段 renderCurriculumSection (跟 ebb16a0 一致, 跟辉哥图 1:1)
  //   卡片 1-2 高亮 + 3-4 灰暗 = 现状 scroll IntersectionObserver 触发, Puppeteer viewport 限制截到
  //   实战教训: Coder c.6 觉得 'btn + m.redraw' 是更好的实现, 实际 ebb16a0 的 div + mithril auto-redraw 行为已经够用, 改了反而跟辉哥期望不一致
  renderCurriculumSection(curriculum, s) {
    return m('section', {
      class: 'bjxy-section bjxy-section-alt',
      id: 'curriculum',
      key: 'sec-curriculum'
    }, [m('div', {
      class: 'bjxy-sub'
    }, 'CURRICULUM'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_curriculum
    //   整个 string 都可改 (因为带数字 <n> 级教学体系, 整个写进 setting 更简单)
    //   fallback 保留数字 + '级教学体系' 跟之前一致 (跟 tab '教学体系' 配套)
    m('h2', null, s('bjxy_section_label_curriculum', curriculum.boards.reduce((sum, b) => sum + b.levels.length, 0) + ' 级教学体系')), m('div', {
      class: 'bjxy-curri-tabs'
    }, [curriculum.boards.map((b, i) => m('div', {
      class: 'bjxy-curri-tab' + (this.activeBoard === i ? ' active' : ''),
      onclick: () => {
        this.activeBoard = i;
      },
      key: 'tab' + i
    }, b.name + ' (' + b.levels.length + ' 级)'))]),
    // v0.2.0h (返工) 改: .bjxy-curri-list 加 oncreate/onupdate/onremove 管理 IntersectionObserver
    //   oncreate 初次渲染时 observe 当前 activeBoard 的所有 cards
    //   onupdate 每次 activeBoard 切换 (mitthril re-render) 时 disconnect 老的 + observe 新的
    //   onremove 卸载时 cleanup observer.disconnect() 防内存泄漏 (SOP 158 模式)
    m('div', {
      class: 'bjxy-curri-list',
      oncreate: _ref2 => {
        let {
          dom
        } = _ref2;
        return this.setupLevelObserver(dom);
      },
      onupdate: _ref3 => {
        let {
          dom
        } = _ref3;
        return this.setupLevelObserver(dom);
      },
      onremove: _ref4 => {
        let {
          dom
        } = _ref4;
        if (dom && dom._levelObserver) {
          dom._levelObserver.disconnect();
          dom._levelObserver = null;
        }
      }
    }, (curriculum.boards[this.activeBoard] ? curriculum.boards[this.activeBoard].levels : []).map((l, i) => m('div', {
      class: 'bjxy-level-card',
      key: 'c' + i
    }, [m('div', {
      class: 'bjxy-level-num'
    }, 'Lv ' + (i + 1)), m('div', {
      class: 'bjxy-level-lvl'
    }, l.level || ''), m('div', {
      class: 'bjxy-level-name'
    }, l.name || ''), m('div', {
      class: 'bjxy-level-desc'
    }, l.desc || '')])))]);
  }

  // 教练展示
  // v0.2.0ebb16a0.c.b 改 (辉哥 2026-09-05 00:46 反馈): revert Coder c.6 简化 32 行 + 改 5 处
  //   现象: bjxy.top 教练 section 显示 "暂无教练" (永远空, 4 个教练数据不显示)
  //   根因: Coder c.6 改 PageStructure 模板时, 简化 renderCoachSection 5 处:
  //     1. class: bjxy-section → bjxy-section bjxy-section-alt (加了 alt, 改 background)
  //     2. h2 fallback: '专业教练' → '认证教练'
  //     3. setting key: bjxy_section_label_coach → bjxy_section_label_coaches (数据库实际是 'coach' 单数, 找不到走 fallback '认证教练')
  //     4. avatar: 删了 srcset retina 适配 + 改 photoUrl → 简单 alt
  //     5. 删 emoji: '🏂 专长' → '专长', '🏆 成就' → '成就'
  //   配套根因: Coder c.6 同时删了 oncreate (调 setTitle + loadCoaches) + loadCoaches 方法
  //   修法: revert renderCoachSection 整段 + 恢复 oncreate + loadCoaches (8/31 ebb16a0 时代一致)
  renderCoachSection(s) {
    return m('section', {
      class: 'bjxy-section',
      id: 'coach',
      key: 'sec-coach',
      style: 'padding: 32px 0px;'
    }, [m('div', {
      class: 'bjxy-sub'
    }, 'COACH'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_coach
    //   之前 hardcode '专业教练', 辉哥本意可以改成 '教练团队' 等
    m('h2', null, s('bjxy_section_label_coach', '专业教练')), this.loadingCoaches ? m('p', null, '加载中...') : this.coaches.length === 0 ? m('p', null, '（暂无教练, 请在后台选择用户组）') : m('div', {
      class: 'bjxy-coach-swiper swiper',
      oncreate: vnode => this.initCoachSwiper(vnode)
    }, [m('div', {
      class: 'swiper-wrapper'
    }, this.coaches.map((c, i) => m('div', {
      class: 'swiper-slide bjxy-coach-slide',
      key: 'c' + i
    }, [
    // v0.1.27 改 (A 方案): 删原来的 detail 二分判断, 所有 coach 统一走详细卡片样式
    //   没字段的字段 (bio/achievements/specialties) 在下方三元判断自动隐藏, 不显示空白
    // v0.2.0g 改: fof-user-bio 写了时, .bjxy-coach 加 bjxy-coach--has-fof-user-bio BEM 修饰符
    //   配合 less 条件式选择器 .bjxy-coach:not(.bjxy-coach--has-fof-user-bio) .bjxy-coach-bio { border-top: ... }
    //   fof-user-bio 写了时: 隐藏 bio border-top 分割线 (下方没 specialties/achievements 段, 分割线没意义)
    //   fof-user-bio 没写时: 保留分割线 (下方有 specialties/achievements 段, 分割线分隔)
    //   辉哥 13:33 反馈: "还有个分割线的残留, 如果填了 fof user bio 的话这个分割线也去掉吧"
    m('div', {
      class: 'bjxy-coach' + (c.bio_from_fof_user_bio ? ' bjxy-coach--has-fof-user-bio' : ''),
      // v0.2.0i.j 新 (辉哥 2026-08-12 10:07 反馈): 教练卡片 click 跳转 /u/{username} 用户页面
      //   修 v0.1.0 历史 feature gap: 之前 .bjxy-coach div 没绑 onclick, 点击无反应
      //   BjxyCoachModal.jsx 存在但没人调用 (保留, 跟现在 onclick 跳转共存不影响)
      //   跳 mithril 路由 /u/{username} 走 vendor Forum user page 渲染
      //   swiper 11 拖动 vs click 不冲突: swiper 默认 preventClicks: false, short tap 触发 click, long press 触发拖动
      //   mithril 0.2.x m() div 加 onclick 直接生效, 不用 wrap <a> 避免 vendor LinkButton 副作用
      //   5 教练卡片 [6,7,5,8,1] → /u/wfl /u/hyw /u/zsj /u/dsl /u/Ziven (跟 bjxy_coach_user_ids 顺序一致)
      //   路由切换: /bjxy unmount (onremove 跑 body class remove) → vendor user page 渲染, OK
      onclick: () => m.route.set('/u/' + c.username)
    }, [
    // v0.1.36a 改回: 横向布局 (辉哥 22:15 反馈)
    //   辉哥本意: avatar 单独在左, name + username 跟在 avatar 下方, info 还是在右侧
    //   v0.1.36 Coder 改成全 vertical 堆叠是错的, 现在拆 .bjxy-coach-left column 包 avatar + meta
    //   info (.bjxy-coach-info) 单独放在 .bjxy-coach-left 右侧
    m('div', {
      class: 'bjxy-coach-left'
    }, [m('div', {
      class: 'bjxy-coach-avatar'
    }, [
    // v0.1.10 改: 用用户自己的系统头像 (user.avatar_url 走 vendor User::getAvatarUrlAttribute() accessor 拼 URL)
    //   + srcset 走 2x/3x 让 Retina 屏幕清晰
    c.avatarUrl ? m('img', {
      src: c.avatarUrl,
      srcset: c.avatarSrcset || null,
      alt: c.displayName,
      loading: 'lazy'
    }) : (c.displayName || '?').charAt(0)]),
    // v0.1.36a 保留: name + username 单独块, 跟 avatar 间距 12px (新加 .bjxy-coach-left column 模式)
    //   辉哥 21:52 反馈: 教练 name/username 放到头像下方, 跟头像保持合适的间距
    m('div', {
      class: 'bjxy-coach-meta'
    }, [m('div', {
      class: 'bjxy-coach-name'
    }, c.displayName || ''), c.username ? m('div', {
      class: 'bjxy-coach-username'
    }, '@' + c.username) : null])]),
    // v0.1.36 删: name + username (移到 .bjxy-coach-left 内 .bjxy-coach-meta 块)
    // v0.1.36a 保留: info 单独放在右侧, 跟 .bjxy-coach-left (avatar+meta) 平行
    m('div', {
      class: 'bjxy-coach-info'
    }, [c.specialties ? m('div', {
      class: 'bjxy-coach-specialties'
    }, [m('span', {
      class: 'bjxy-coach-label'
    }, '🏂 专长'), m('span', {
      class: 'bjxy-coach-text'
    }, c.specialties)]) : null, c.achievements ? m('div', {
      class: 'bjxy-coach-achievements'
    }, [m('span', {
      class: 'bjxy-coach-label'
    }, '🏆 成就'), m('span', {
      class: 'bjxy-coach-text'
    }, c.achievements)]) : null,
    // v0.2.0h (返工) 改 (辉哥 2026-08-10 19:00 反馈, bio 渲染跟 fof user bio 不一致):
    //   之前 v0.2.0h (第一次) 走 oncreate + onupdate client-side s9e.TextFormatter.preview (跟 ComposerPostPreview 同模式)
    //   跟 fof user bio /u/Ziven 走的 server-side pre-rendered safe HTML (m.trust 渲染) 不同时机, 视觉有差
    //   (s9e preview 重新 wrap <p> + 加 <br> 位置跟 vendor render 不完全一致, emoji twemoji img 位置也有差)
    //   现在改成 server 端预渲染 (CoachesController 加 bioHtml 字段), 前端 m.trust(c.bioHtml) 直接拿 safe HTML
    //   跟 /u/Ziven 个人页 fof user bio 渲染模式完全一致 (DOM tree <p> / <br> / img.emoji 数量 + textContent 一致)
    //   XSS 防护: bioHtml 已经过 UserBioFormatter->render() (s9e parser 自动 escape 不安全 HTML 标签), 跟 v0.2.0d about_desc 一致
    //   c.bio 字段保留 (API 仍返 plain text) 供后续可能用 (如 alert / notification / search)
    c.bioHtml ? m('div', {
      class: 'bjxy-coach-bio'
    }, m.trust(c.bioHtml)) : null])])]))), m('div', {
      class: 'swiper-pagination'
    })])]);
  }

  // 学员评价
  // v0.1.6 改: 评价走结构化 JSON (app.forum.attribute('bjxy_reviews') 解析)
  //   5 字段: author / rating / text / date / photoUrl
  // v0.1.6a 改: 加 photoUrl 缩略图墙 (大众点评风格, hover zoom + grid 4 列)
  renderReviewsSection(reviews, s) {
    return m('section', {
      class: 'bjxy-section bjxy-section-alt',
      id: 'reviews',
      key: 'sec-reviews'
    }, [m('div', {
      class: 'bjxy-sub'
    }, 'REVIEWS'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_reviews
    m('h2', null, s('bjxy_section_label_reviews', '学员评价')), reviews.length > 0 ? m('div', {
      class: 'bjxy-review-grid'
    }, reviews.map((r, i) => {
      const photos = Array.isArray(r.photos) ? r.photos : r.photoUrl ? [r.photoUrl] : [];
      return m('div', {
        class: 'bjxy-review',
        key: 'r' + i
      }, [m('div', {
        class: 'bjxy-review-stars'
      }, this.renderStars(r.rating || 5)), m('div', {
        class: 'bjxy-review-quote'
      }, r.text || ''), m('div', {
        class: 'bjxy-review-author'
      }, [m('span', {
        class: 'bjxy-review-author-av'
      }, (r.author || '?').charAt(0)), m('span', null, r.author || '匿名'), r.date ? m('span', {
        class: 'bjxy-review-date'
      }, ' · ' + r.date) : null]), photos.length > 0 ? m('div', {
        class: 'bjxy-review-photos'
      }, photos.map((url, pi) => m('a', {
        key: 'rp' + i + 'p' + pi,
        class: 'bjxy-review-photo',
        style: {
          backgroundImage: 'url(' + url + ')'
        },
        onclick: e => {
          e.preventDefault();
          this.openFancyboxGallery(photos, pi);
        }
      }))) : null]);
    })) : m('p', null, '（暂无评价, 请在后台添加）')]);
  }

  // 联系我们
  // v0.1.32 改 (辉哥 11:48 反馈): 地址 改多地址 (bjxy_contact_addresses), 微信 改多图 (bjxy_contact_wechat_images)
  //   保留兼容老 setting (bjxy_contact_address 单值 + bjxy_contact_wechat 单值)
  //   优先用新字段, 老字段为空时 fallback 老单值
  // v0.2.0ebb16a0.c.e 改 (辉哥 2026-09-05 00:57 反馈): revert Coder c.6 改坏的 7 处 contact section
  //   现象: 辉哥发 contact section 目标图, 实际 bjxy.top 缺 4 段关键内容:
  //     - 缺副标题 '有任何问题, 欢迎随时联系, 我们 24 小时内回复'
  //     - 缺 VISIT US 蓝色 banner 卡片 (大型滑雪模拟机 · 室内四季恒温 + 营业时间 10:00 - 22:00)
  //     - 段从 .bjxy-contact-segment → .bjxy-contact-block (Coder 改错, less 段样式没匹配)
  //     - 微信 grid 从 .bjxy-contact-wechat-grid → .bjxy-contact-wechat (Coder 改错, less 段样式没匹配)
  //   根因: Coder c.6 改 PageStructure 模板时, 删/改了 renderContactSection 7 处:
  //     1. 删 .bjxy-contact-image VISIT US 蓝色 banner 卡片 (辉哥图最大差异)
  //     2. 删 .bjxy-section-desc 副标题 '有任何问题...'
  //     3. class 改 bjxy-section bjxy-section-alt → 错了, ebb16a0 是 bjxy-section (没 alt)
  //     4. 段类名 .bjxy-contact-segment → .bjxy-contact-block (less 段没 .bjxy-contact-block 样式)
  //     5. 微信 grid 类名 .bjxy-contact-wechat-grid → .bjxy-contact-wechat (less 段没 .bjxy-contact-wechat 样式)
  //     6. label 简化: '地址 · ADDRESS' → '📍 门店地址', '电话 · PHONE' → '📞 联系电话', '微信 · WECHAT' → '💬 微信'
  //     7. 删 phone fallback '400-888-8888' 默认值
  //   修法 (Mavis 自己干 9/5 00:59): revert renderContactSection 整段 (跟 ebb16a0 一致)
  //   配套: 加回 .bjxy-contact-image (VISIT US banner), 副标题, 4 段 segment (地址/电话/微信 + 可选邮箱)
  //   实战教训: Coder c.6 觉得 'VISIT US 蓝色 banner 是冗余, 删了简化' — 实际是客户隐式偏好的视觉锚点
  renderContactSection(s) {
    // 解析多地址 (array of {value} → array of string)
    const addresses = (() => {
      try {
        const raw = s('bjxy_contact_addresses', '[]');
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          return arr.map(a => typeof a === 'string' ? a : a && a.value || '').filter(Boolean);
        }
      } catch (e) {}
      // 向后兼容: 旧 bjxy_contact_address 单值 → [old]
      const old = s('bjxy_contact_address', '');
      return old ? [old] : [];
    })();
    // 解析多图微信 (array of URL)
    const wechatImages = (() => {
      try {
        const raw = s('bjxy_contact_wechat_images', '[]');
        const arr = JSON.parse(raw);
        return Array.isArray(arr) ? arr.filter(Boolean) : [];
      } catch (e) {
        return [];
      }
    })();
    return m('section', {
      class: 'bjxy-section',
      id: 'contact',
      key: 'sec-contact',
      style: 'padding: 0px 0px 32px 0px'
    }, [m('div', {
      class: 'bjxy-sub'
    }, 'CONTACT'),
    // v0.2.0g 改 (辉哥 2026-08-10 7:40 反馈): h2 改读 bjxy_section_label_contact
    // v0.5.10.c 撤 (辉哥 2026-08-30 23:44 反馈): 删 v0.5.10.a.b 加的 .bjxy-contact-header flex 包 h2 + "测试" 按钮
    //   iPhone 真机亲测后确认: Flarum 2.0 原生 modal 自身 bug, 不管 BookingModal 还是 TestModal 都跳顶
    //   "测试" 按钮本身是临时调试用, 调试结论出来后没用了, 撤
    m('h2', null, s('bjxy_section_label_contact', '联系我们')), m('p', {
      class: 'bjxy-section-desc'
    }, '有任何问题, 欢迎随时联系, 我们 24 小时内回复'), m('div', {
      class: 'bjxy-contact-grid'
    }, [
    // v0.2.0i 新加: B 方案左大图 (mobile only, desktop 默认 display: none)
    //   蓝渐变 + ⛰ emoji 占位 + meta 段 (跟 B_left_image.html 一致)
    m('div', {
      class: 'bjxy-contact-image',
      key: 'image'
    }, [m('div', {
      class: 'bjxy-contact-image-inner'
    }, [m('div', {
      class: 'bjxy-contact-image-mock'
    }), m('div', {
      class: 'bjxy-contact-image-meta'
    }, [m('div', {
      class: 'bjxy-contact-image-eyebrow'
    }, 'VISIT US'), m('div', {
      class: 'bjxy-contact-image-title'
    }, '大型滑雪模拟机 · 室内四季恒温'), m('div', {
      class: 'bjxy-contact-image-sub'
    }, '营业时间 10:00 - 22:00')])])]),
    // v0.2.0i 改: 段从 .bjxy-contact-item 卡片 → .bjxy-contact-segment 扁平段 (辉哥 15:12 反馈, 不要卡片式)
    //   地址 (多地址, 段内多行, 跟 A_flat_list_desktop 一致)
    m('div', {
      class: 'bjxy-contact-segment',
      key: 'address'
    }, [m('div', {
      class: 'bjxy-contact-label'
    }, '地址 · ADDRESS'), m('div', {
      class: 'bjxy-contact-value'
    }, addresses.length > 0 ? addresses.map((addr, i) => m('span', {
      class: 'bjxy-contact-value-item',
      key: 'addr-' + i
    }, addr)) : m('span', {
      class: 'bjxy-contact-value-item'
    }, '敬请期待'))]),
    // 电话 (单值保留)
    m('div', {
      class: 'bjxy-contact-segment',
      key: 'phone'
    }, [m('div', {
      class: 'bjxy-contact-label'
    }, '电话 · PHONE'), m('div', {
      class: 'bjxy-contact-value'
    }, s('bjxy_contact_phone', '400-888-8888'))]),
    // 微信 (多图, 走 40x40 thumbnail 紧凑 flex 布局)
    wechatImages.length > 0 ? m('div', {
      class: 'bjxy-contact-segment bjxy-contact-wechat',
      key: 'wechat'
    }, [m('div', {
      class: 'bjxy-contact-label'
    }, '微信 · WECHAT'), m('div', {
      class: 'bjxy-contact-wechat-grid'
    }, wechatImages.map((url, i) => m('a', {
      class: 'bjxy-contact-wechat-img',
      href: url,
      target: '_blank',
      rel: 'noopener noreferrer',
      key: 'wc-' + i
    }, m('img', {
      src: url,
      alt: '微信二维码 #' + (i + 1)
    }))))]) : null].filter(Boolean))]);
  }
}
flarum.reg.add('ziiven-bjxy-website', 'forum/components/BjxyPage', BjxyPage);